import React, { useState } from 'react';
import { useTrail, animated } from 'react-spring';
import { options } from '../reasons';
import './LeaveForm.css';

const LeaveForm = ({ onGenerate }) => {
  const [formData, setFormData] = useState({
    profession: options.professions[0],
    experience: options.experiences[0],
    style: options.styles[0].value,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onGenerate(formData);
  };

  const formItems = [
    <div className="form-group">
      <label>工作多少年啦？</label>
      <select name="experience" value={formData.experience} onChange={handleChange}>
        {options.experiences.map((e) => <option key={e} value={e}>{e}</option>)}
      </select>
    </div>,
    <div className="form-group">
      <label>想要什么风格的理由？</label>
      <div className="style-options">
        {options.styles.map((s) => (
          <label key={s.value} className="radio-label">
            <input
              type="radio"
              name="style"
              value={s.value}
              checked={formData.style === s.value}
              onChange={handleChange}
            />
            <span>{s.label}</span>
          </label>
        ))}
      </div>
    </div>
  ];

  const trail = useTrail(formItems.length + 1, { // +1 for the button
    config: { mass: 1, tension: 280, friction: 25 },
    from: { opacity: 0, transform: 'translateY(20px)' },
    to: { opacity: 1, transform: 'translateY(0px)' },
  });

  return (
    <form onSubmit={handleSubmit} className="leave-form">
      {formItems.map((item, index) => (
        <animated.div key={index} style={trail[index]}>
          {item}
        </animated.div>
      ))}
      <animated.div style={trail[formItems.length]}>
        <button type="submit" className="generate-btn">
          一键生成！
        </button>
      </animated.div>
    </form>
  );
};

export default LeaveForm;
